<ng-container *ngIf="contractDuration$ | async as contractDuration">
  <ng-container *ngIf="contractDuration?.length">
    <div class="d-flex flex-wrap align-items-center justify-content-start">
      <div class="w-100">
        <ds-radio-group
          (ngModelChange)="emitSelectedDuration()"
          [formControl]="formControl"
          [data]="contractDuration"
        ></ds-radio-group>
      </div>
    </div>
  </ng-container>
</ng-container>
